import { applySnapshot, getSnapshot, types as t } from 'mobx-state-tree';

export const RecurringTransactionListModel = t.model('RecurringFileListModel', {
  id: t.string,
  onboarding_batch_id: t.maybeNull(t.string),
  batch_name: t.maybeNull(t.string),
  wallet_id: t.maybeNull(t.string),
  mobile_no: t.maybeNull(t.string),
  transaction_at: t.maybeNull(t.string),
  amount: t.maybeNull(t.number),
  transaction_id: t.maybeNull(t.string),
  merchant_tx_short_id: t.maybeNull(t.string),
  merchant_id: t.maybeNull(t.string),
  merchant_name: t.maybeNull(t.string),
  reference_number: t.maybeNull(t.string),
  status: t.maybeNull(t.string),
  reject_reason: t.maybeNull(t.string),
  amount_string: t.maybeNull(t.string),
});

export const RecurringTransactionModel = t
  .model('RecurringTransactionModel', {
    list: t.array(RecurringTransactionListModel),
    pagination: t.model('Pagination', {
      total_count: t.optional(t.number, 0),
      current_page: t.optional(t.number, 0),
      total_pages: t.optional(t.number, 0),
    }),
  })
  .actions((self) => {
    let initialState = {};
    return {
      afterCreate() {
        initialState = getSnapshot(self);
      },
      reset() {
        applySnapshot(self, initialState);
      },
    };
  });

export default RecurringTransactionModel;
